module.exports = __webpack_public_path__ + "static/media/voucherGreen.cc70f0f4.png";